import { Ref } from "react";

import { DDQForm, FormConfig } from "../types";
import FormSection, { Mode } from "./FormSection";

export type Props = {
  register?: () => Ref<any>;
  mode: Mode;
  form: DDQForm;
};

export default function ProductsServicesFormSection({ mode, register, form }: Props) {
  const formConfig: FormConfig = {
    activities: {
      type: "multipleChoice",
      label: "4A. Select the business activities applicable to the entity",
      choices: [
        { label: "Exchange between virtual assets and fiat currencies", value: "virtualAssetsAndFiat" },
        { label: "Exchange between one or more forms of virtual assets", value: "betweenVirtualAssets" },
        { label: "Transfer of virtual assets", value: "transferVirtualAssets" },
        {
          label:
            "Safekeeping and/or administration of virtual assets or instruments enabling control over virtual assets",
          value: "safekeeping",
        },
        {
          label:
            "Participation in and provision of financial services related to an issuer's offer and/or sale of a virtual assets",
          value: "participationIssuer",
        },
      ],
    },
    services: {
      type: "multipleChoice",
      label: "4B. Does the Entity offer the following products and services?",
      choices: [
        {
          label:
            "Fiat to crypto deposits or withdrawals to / from a bank account not verified as in the customer's name",
          value: "offersUnverifiedCryptoDepositsWithdrawals",
        },
        { label: "Crypto exchange involving privacy coins", value: "cryptoPrivacyCoins" },
        { label: "Peer-to-peer exchange", value: "peer2peer" },
        { label: "Omnibus or co-mingled custodial wallets", value: "omnibusOrComingledCustodialWallets" },
        { label: "OTC trading for non-account holders", value: "otcTradingNonAccountHolders" },
        {
          label:
            "Issuance, fund raising or collection of funds for initial coin offerings (ICO) / initial exchange offerings (IEO) / security token offerings (STO) / private token sales",
          value: "icoIeoSto",
        },
        { label: "Unregulated investment funds", value: "unregulatedInvestmentFunds" },
        { label: "Crypto ATMs", value: "cryptoAtms" },
        { label: "Other high risk products and services identified by the entity", value: "otherRiskyProducts" },
        {
          label: "None of the above",
          value: "noProductsServices",
        },
      ],
    },
  };

  return (
    <FormSection
      title="Section 4. Products & services"
      formConfig={formConfig}
      register={register}
      mode={mode}
      form={form}
    />
  );
}
